export const getDataHome = (state) => {
  return state.dataHome;
}